import React, { useRef } from 'react';
import { Button, Container } from 'reactstrap';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { useNavigate } from 'react-router-dom';

const animationClass = {
    appearActive: 'animate__animated animate__slideInRight',
    enter: 'animate__animated',
    enterActive: 'animate__animated animate__slideInRight',
    exit: 'animate__animated',
    exitActive: 'animate__animated animate__slideOutLeft',
}

export const ResetPasswordDone = () => {
    const navigate = useNavigate();
    const nodeRef = useRef(null);

    return (
        <Container fluid="xl" className='minvh-100 overflow-hidden position-relative'>
            <TransitionGroup component={null} >
                <CSSTransition nodeRef={nodeRef} classNames={animationClass} timeout={{ enter: 1000, exit: 1000 }} key='confirm' appear >
                    <div ref={nodeRef} className='d-flex flex-column align-items-center minvh-100'>
                        <div className="forgot-password-page bg-white rounded p-4 py-5 my-auto align-content-center" style={{ height: '379px' }}>
                            <div className="d-flex justify-content-center text-green">
                                <svg width="80" height="81" viewBox="0 0 80 81" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <rect y="0.5" width="80" height="80" rx="40" fill="currentColor" />
                                    <path d="M58.0164 34.7074L37.9539 54.7699C37.4851 55.2384 36.8495 55.5016 36.1867 55.5016C35.524 55.5016 34.8883 55.2384 34.4195 54.7699L23.2289 43.5199C22.7609 43.0512 22.498 42.4159 22.498 41.7535C22.498 41.0912 22.7609 40.4559 23.2289 39.9871L26.3539 36.8621C26.8225 36.3955 27.4568 36.1336 28.118 36.1336C28.7792 36.1336 29.4135 36.3955 29.882 36.8621L36.2492 43.0371L51.368 28.1043C51.8366 27.6373 52.4712 27.375 53.1328 27.375C53.7944 27.375 54.4291 27.6373 54.8977 28.1043L58.0149 31.1574C58.2493 31.3897 58.4354 31.6662 58.5624 31.9708C58.6895 32.2753 58.755 32.6021 58.7551 32.9321C58.7553 33.2621 58.6901 33.5889 58.5633 33.8936C58.4365 34.1983 58.2506 34.4749 58.0164 34.7074Z" fill="white" />
                                </svg>
                            </div>

                            <div className="mt-4 mb-3">
                                <h1 className="libre-caslon-text-regular h3-md h4 mb-0 text-center"> Password created successfully! </h1>
                                <p className="text-center pt-3">you have created new password successfully, click button to signin into your account</p>
                            </div>

                            <div className="d-flex justify-content-center">
                                <Button type="submit" color="green-light" className='rounded-sm' size='sm' onClick={() => navigate('/login')}>
                                    Sign in to account
                                </Button>
                            </div>
                        </div>
                    </div>
                </CSSTransition>
            </TransitionGroup>
        </Container>
    )
}